<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <g clip-path="url(#clip0_12105_170850)">
    <path d="M8.92961 14.6965L8.13684 15.4827C7.80116 15.8155 7.25837 15.8155 6.92626 15.4827L-0.0158205 8.60196C-0.351497 8.26908 -0.351497 7.73081 -0.0158205 7.40147L6.92626 0.517238C7.26194 0.184358 7.80474 0.184358 8.13684 0.517238L8.92961 1.3034C9.26886 1.63982 9.26172 2.18872 8.91533 2.51806L4.61224 6.58344L14.8754 6.58344C15.3503 6.58344 15.7324 6.96235 15.7324 7.43334V8.56655C15.7324 9.03754 15.3503 9.41645 14.8754 9.41645L4.61224 9.41645L8.91533 13.4818C9.26529 13.8112 9.27243 14.3601 8.92961 14.6965Z" fill="#009AFF"/>
  </g>
  <defs>
    <clipPath id="clip0_12105_170850">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>